import script from "./TabsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsPage.vue?vue&type=script&setup=true&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=8abf29da&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8abf29da"]])

export default __exports__